import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './i18n';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from "react-router";
import { MsalProvider } from '@azure/msal-react';
import msalInstance from './configs/auth/msalInstance';
import { EventType } from '@azure/msal-browser';
import { PageTitleProvider } from './context/pageTitleContext';
import { UserProvider } from './context/UserContext';
import { LoaderProvider } from './context/loaderContext';
import store from './state/store';
import { Provider } from 'react-redux';
import { FullScreenLoaderProvider } from './context/fullScreenLoaderContext';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const container = document.getElementById('root');
if (!container) {
  throw new Error("Root container not found. Unable to mount the React app.");
}
const root = ReactDOM.createRoot(container);
const queryClient = new QueryClient();

msalInstance.initialize().then(() => {
  // Ensure redirect responses are handled before rendering
  return msalInstance.handleRedirectPromise();
}).finally(() => {
  root.render(
      // <React.StrictMode>
      <Provider store={store}>
        <MsalProvider instance={msalInstance}>
          <Router>
            <UserProvider>
              <PageTitleProvider>
                <FullScreenLoaderProvider>
                <LoaderProvider>                       
                  <QueryClientProvider client={queryClient}>
                    <App />
                  </QueryClientProvider>
                </LoaderProvider>
                </FullScreenLoaderProvider>
              </PageTitleProvider>
            </UserProvider>
          </Router>
        </MsalProvider>
      </Provider>
      // </React.StrictMode>
    );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
